module.exports = __webpack_public_path__ + "static/media/refresh.9eb3ebf5.png";